/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import BookingStepList from "../components/booking/steps/BookingStepList";
import Container from "../components/Container";
import LocationsList from "../components/booking/location/LocationsList";
import NavigationHeader from "../components/NavigationHeader";

const Locations = () => {
    return (
        <Container>
            <NavigationHeader cart clientLogin navigation />
            <BookingStepList title="Choose location">
                <LocationsList />
            </BookingStepList>
        </Container>
    );
};

export default Locations;
